import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  section: {
    padding: '0.5rem 0 0.25rem',
    display: 'flex',
    rowGap: '0.5rem',
    flexDirection: 'column',
    borderTop: '1px solid #000',
    borderBottom: '1px solid #000',
  },
  error: {
    fontWeight: 'bold',
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },
  item: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    fontWeight: 'normal',
    fontSize: '0.875rem',
    lineHeight: '1rem',
    letterSpacing: '-0.015rem',
    '&[aria-label="totals-main-item"]': {
      fontSize: '1rem',
    },
  },
});
